import React from 'react';
import ReactDOM from 'react-dom';

import { createHashHistory } from 'History';

import { Router, Route, useRouterHistory } from 'react-router'

import { syncHistoryWithStore, RouterStore } from 'mobx-react-router';

import { Provider } from 'mobx-react';

import Hrm from 'weaHrm' //umd

const routing = new RouterStore();

const allStore = {
  routing,
  ...Hrm.store,
}

const HrmRoute = Hrm.Route;

const browserHistory = useRouterHistory(createHashHistory)({
  queryKey: '_key',
  basename: '/'
});

const history = syncHistoryWithStore(browserHistory, allStore.routing);

const Home = props => props.children;

const Root = () => (
  <Provider ecId={`${this && this.props && this.props.ecId || ''}_Provider@dij8x7`} {...allStore}>
    <Router ecId={`${this && this.props && this.props.ecId || ''}_Router@0aavs3`} history={history}>
      <Route ecId={`${this && this.props && this.props.ecId || ''}_Route@fm65r2`} name="main" breadcrumbName="入口" path="/main" component={Home}>
        { HrmRoute }
      </Route>
    </Router>
  </Provider>
);

ReactDOM.render(<Root ecId={`${this && this.props && this.props.ecId || ''}_Root@kqnheg`}/>, document.getElementById('container'));



// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/single.js